import React, { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { PAGINATION_DEFAULT } from "../../../../utils/constants";
import Button from "../../../button";
import DataTable from "../../../datatable";
import {
  useGetBranchDepartments,
  useRemoveDepartmentFromBranch,
} from "../../../../redux/human-resources/hook/branches";
import AddDepartmentsToBranch from "../../../modal/hr-section/branches/add-branch-department";

const BranchDepartmentTab = () => {
  useEffect(() => {}, []);

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: "",
  });
  const { id } = useParams();

  const { data: branch_departments } = useGetBranchDepartments(
    id,
    pagination?.limit,
    pagination?.page,
    pagination?.search
  );

  const [showAddDepartmentToBranch, setShowAddDepartmentToBranch] =
    useState(false);
  const { mutateAsync: removeFromBranch } = useRemoveDepartmentFromBranch();

  const tableConfig = {
    headers: ["Date Added", "Branch Name", "Department Name"],
    keys: ["created", "branch_name", "department_name"],
    mobileHeader: {
      left: {
        title: "Date Added",
        key: "created",
      },
      right: {
        title: "Department Name",
        key: "department_name",
      },
    },
  };

  const actionConfig = [
    {
      name: "Remove",
      color: "red",
      action: (id) => {
        let index = branch_departments.data.findIndex((item) => item.id == id);
        if (index != -1) {
          removeFromBranch({
            branchdepartment_lists:
              branch_departments.data[index].id.toString(),
          });
        }
      },
    },
  ];

  const bulkActionConfig = [
    {
      label: "Remove",
      value: "active",
      action: (data) => {
        let newData = data.split(",");
        let result = [];

        newData.forEach((id) => {
          let index = branch_departments.data.findIndex(
            (item) => item.id == id
          );
          if (index != -1) {
            result.push(branch_departments.data[index].id);
          }
        });
        removeFromBranch({ branchdepartment_lists: result.join(",") });
      },
    },
  ];

  return (
    <div className="flex flex-col bg-white rounded">
      {showAddDepartmentToBranch ? (
        <AddDepartmentsToBranch
          isOpen={showAddDepartmentToBranch}
          branchData={id}
          closeModal={() => setShowAddDepartmentToBranch(false)}
        />
      ) : null}
      <div className="flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3">
        <div className="md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full">
          Departments
        </div>
        <div className="flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[60%] w-full">
          <div className="md:w-fit w-[100%]">
            <Button
              text="Add Department To Branch"
              type="submit"
              leftIcon={"add"}
              className="flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center"
              textClass={"!text-[11px]"}
              onClick={() => setShowAddDepartmentToBranch(true)}
            />
          </div>
        </div>
      </div>
      <hr className="divider mt-2" />
      <DataTable
        data={branch_departments}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        bulkActionConfig={bulkActionConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        searchData={true}
      />
    </div>
  );
};

export default BranchDepartmentTab;
